import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-5xl font-heading font-extralight text-foreground-900 mb-3">
              {t('articles.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              {t('articles.subtitle')}
            </p>
          </div>
          <a
            href="/guia-de-compras"
            onClick={(e) => {
              e.preventDefault();
              navigate('/guia-de-compras');
            }}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('articles.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, idx) => (
            <a
              key={article.slug}
              href={`/artigo/${article.slug}`}
              onClick={(e) => {
                e.preventDefault();
                navigate(`/artigo/${article.slug}`);
              }}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-4 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <span
                  className={`inline-flex items-center justify-center w-full px-4 py-2.5 text-xs font-semibold rounded-full transition-all whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 text-white hover:bg-primary-600'
                      : 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  }`}
                >
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line ml-1.5 text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="/guia-de-compras"
            onClick={(e) => {
              e.preventDefault();
              navigate('/guia-de-compras');
            }}
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-background-100 text-foreground-700 border border-background-300 rounded-full hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('articles.viewAllArticles')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}